import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { ApproveContainer, BottomActionsContainer } from './styled'

const Approve = (props) => {
  
  const { 
    valueForm, 
    //props
    onCancelClick=null
  } = props

  return (
    <StdCard title={<span className='stepTitle'>Update</span>} highlight enableCollapse={false}>
      <ApproveContainer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Field
            name='comment'
            label='Your Comment'
            type={type.textArea}
            containerStyle={{ marginRight: '0px' }}
            component={FieldInput} 
            require/>
          <BottomActionsContainer>
            <Button
              type='button'
              content='Cancel'
              color='red'
              onClick={onCancelClick}
            />
            <Button
              content='Save and Update'
              color='green'
            />
          </BottomActionsContainer>
        </div>
      </ApproveContainer>
    </StdCard>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formBGCompany')(state) || {},
  })
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Approve))
